/** @format */

import { IEnvironment } from './environment.interface';

export const baseEnvironment: Omit<IEnvironment, 'appName' | 'production' | 'env'> = {
  region: 'eu-west-1',
  noosGatewayUrl: 'https://endpoint.noos.sesio.io',
  mapboxAccessToken: 'pk.eyJ1IjoiZWhlcnZlIiwiYSI6ImNsOHlrZGFlcDA5NmUzdnBrOHR3bHdxY3gifQ.1tU0KXJak2Dh1yqA6sOpZQ',
};
